<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 9 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.50391 6.00234H2.49609C2.15234 6.00234 1.82813 6.06487 1.52344 6.18992C1.21875 6.32278 0.953126 6.50058 0.726562 6.72333C0.499999 6.94607 0.324219 7.20985 0.199219 7.51465C0.0664056 7.81946 0 8.14771 0 8.49941V9.4959C0 9.65221 0.0449214 9.7753 0.134766 9.86518C0.22461 9.95506 0.347655 10 0.503906 10C0.652344 10 0.771484 9.95506 0.861328 9.86518C0.951172 9.7753 0.996094 9.65221 0.996094 9.4959V8.49941C0.996094 8.07737 1.14062 7.72177 1.42969 7.43259C1.71875 7.14341 2.07422 6.99883 2.49609 6.99883H6.50391C6.92578 6.99883 7.28125 7.14341 7.57031 7.43259C7.85938 7.72177 8.00391 8.07737 8.00391 8.49941V9.4959C8.00391 9.65221 8.04883 9.7753 8.13867 9.86518C8.22852 9.95506 8.34766 10 8.49609 10C8.65234 10 8.77539 9.95506 8.86523 9.86518C8.95508 9.7753 9 9.65221 9 9.4959V8.49941C9 8.14771 8.93359 7.81946 8.80078 7.51465C8.67578 7.20985 8.5 6.94607 8.27344 6.72333C8.04687 6.50058 7.78125 6.32278 7.47656 6.18992C7.17187 6.06487 6.84766 6.00234 6.50391 6.00234ZM4.5 4.99414C4.85156 4.99414 5.17969 4.93161 5.48438 4.80656C5.78906 4.6737 6.05273 4.4959 6.27539 4.27315C6.49805 4.05041 6.67578 3.78664 6.80859 3.48183C6.93359 3.17702 6.99609 2.84877 6.99609 2.49707C6.99609 2.14537 6.93359 1.81712 6.80859 1.51231C6.67578 1.2075 6.49805 0.943729 6.27539 0.720985C6.05273 0.49824 5.78906 0.320438 5.48438 0.187573C5.17969 0.0625239 4.85156 0 4.5 0C4.14844 0 3.82031 0.0625239 3.51563 0.187573C3.21094 0.320438 2.94727 0.49824 2.72461 0.720985C2.50195 0.943729 2.32422 1.2075 2.19141 1.51231C2.06641 1.81712 2.00391 2.14537 2.00391 2.49707C2.00391 2.84877 2.06641 3.17702 2.19141 3.48183C2.32422 3.78664 2.50195 4.05041 2.72461 4.27315C2.94727 4.4959 3.21094 4.6737 3.51563 4.80656C3.82031 4.93161 4.14844 4.99414 4.5 4.99414ZM4.5 0.996483C4.92188 0.996483 5.27734 1.14107 5.56641 1.43025C5.85547 1.71942 6 2.07503 6 2.49707C6 2.91911 5.85547 3.27472 5.56641 3.56389C5.27734 3.85307 4.92188 3.99766 4.5 3.99766C4.07812 3.99766 3.72266 3.85307 3.43359 3.56389C3.14453 3.27472 3 2.91911 3 2.49707C3 2.07503 3.14453 1.71942 3.43359 1.43025C3.72266 1.14107 4.07812 0.996483 4.5 0.996483Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      default: "#4d4c4c",
      type: String
    },
    height: {
      default: 10,
      type: [Number, String]
    },
    width: {
      default: 9,
      type: [Number, String]
    }
  }
};
</script>
